import axios from 'axios'

export const getAllBank = (params) => {
  let remoteUrl = 'banks'

  return axios.get(remoteUrl, {params: params})
}

export const getBank = (id, params) => {
  return axios.get('banks/' + id, {params: params})
}

export const newBank = (data) => {
  return axios.post('banks', data)
}

export const editBank = (id, data) => {
  return axios.put('banks/' + id, data)
}

export const deleteBank = (id) => {
  return axios.delete('banks/' + id)
}



// WEBPACK FOOTER //
// ./src/api/bank.js